import rawElements from "../assets/elements.json";
import Element from "../models/Element";

const elements = [];
const elementHighest = {
  x: 0,
  y: 0,
};

const processRawElements = (raw) => {
  for (let rawEl of raw) {
    const el = new Element(rawEl);
    elementHighest.x = Math.max(el.px, elementHighest.x);
    elementHighest.y = Math.max(el.py, elementHighest.y);
    elements.push(el);
  }
};

processRawElements(rawElements);

export { elementHighest };
export default elements;
